import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/pro-solid-svg-icons/faCheckCircle';
import Translate from '../translate/translate';
import { h } from 'preact';

const ThankYou = () => {
	return (
		<div className="thank-you">
			<span className="icon">
				<FontAwesomeIcon icon={faCheckCircle} />
			</span>
			<span className="header aria-focus" tabIndex={0}>
				<Translate text="RATING.THANK_YOU" />
			</span>
			<span className="sub-header">
				<Translate text="RATING.FOR_USING_OUR_SERVICE" />
			</span>
		</div>
	);
};

export default ThankYou;
